export default "__VITE_ASSET__DVYdykxk__"